export default "__VITE_ASSET__Br1Pnvnc__"